/* eslint-disable @typescript-eslint/no-explicit-any */

import { FC, useEffect, useState } from 'react';
import { useTranslation } from 'react-i18next';
import { Nullable } from 'primereact/ts-helpers';
import classNames from 'classnames';
import { InputDateField, DropdownField, InputTextField } from '@/components';
import styles from './Filters.module.scss';

import { TableFilters } from './TableFiltersType';

import { getStatusOptions, getTypeOptions } from './data';

type FiltersProps = {
  filters: TableFilters;
  setFilters: (filters: TableFilters) => void;
};

type Option = { name: string; value: string };

const Filters: FC<FiltersProps> = ({ filters, setFilters }) => {
  const { t } = useTranslation('tableFilters');
  const [statusOptions, setStatusOptions] = useState<Option[]>([]);
  const [typeOptions, setTypeOptions] = useState<Option[]>([]);

  useEffect(() => {
    setStatusOptions(getStatusOptions(t));
    setTypeOptions(getTypeOptions(t));
  }, [t]);

  const handleFilterChange = (
    value: string | Nullable<Date>,
    field: keyof TableFilters
  ) => {
    const newFilters = {
      ...filters,
      [field]: value,
    };

    setFilters(newFilters);
  };

  return (
    <div className={styles.container}>
      <DropdownField
        id="tipo"
        name="tipo"
        multiple
        value={filters.tipo}
        onChange={(e) => handleFilterChange(e.value, 'tipo')}
        options={typeOptions}
        label={t('type')}
      />
      <DropdownField
        id="estado"
        name="estado"
        multiple
        value={filters.estado}
        onChange={(e) => handleFilterChange(e.value, 'estado')}
        options={statusOptions}
        label={t('status')}
      />
      <InputTextField
        id="contenedor"
        name="contenedor"
        value={filters.contenedor || ''}
        onChange={(e) => {
          let { value } = e.target;
          value = value?.replace(/[^A-Za-z0-9]/g, '');
          handleFilterChange(value, 'contenedor');
        }}
        label={t('container')}
        placeholder={t('containerPlaceholder')}
        inputClassName={classNames(styles.containerInput)}
      />
      <InputDateField
        id="startAt"
        name="startAt"
        value={filters.fechaDesde}
        onChange={(e) => handleFilterChange(e, 'fechaDesde')}
        label={t('startAt')}
        readOnlyInput={false}
        inputClassName={classNames(styles.containerInput)}
      />
      <InputDateField
        id="endAt"
        name="endAt"
        value={filters.fechaHasta}
        onChange={(e) => handleFilterChange(e, 'fechaHasta')}
        label={t('endAt')}
        readOnlyInput={false}
        inputClassName={classNames(styles.containerInput)}
      />
    </div>
  );
};

export default Filters;
